import MyPageMyInfoReducer from './mypagemain/MyPageMyInfoReducer';
import MyPageBenefitReducer from './mypagebenefitinfo/MyPageBenefitReducer';

export { MyPageMyInfoReducer, MyPageBenefitReducer };
